import { render, staticRenderFns } from "./caseReviewTwo.vue?vue&type=template&id=39a868f8&scoped=true"
import script from "./caseReviewTwo.vue?vue&type=script&lang=js"
export * from "./caseReviewTwo.vue?vue&type=script&lang=js"
import style0 from "./caseReviewTwo.vue?vue&type=style&index=0&id=39a868f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a868f8",
  null
  
)

export default component.exports